module.exports = __webpack_public_path__ + "static/media/image_zizhi-wap.d49604db.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/home/image_zizhi-wap.png
// module id = 449
// module chunks = 0